import './EmptyState.css';

type Props = {
  title: string;
  subtitle: string;
};

export default function EmptyState({ title, subtitle }: Props) {
  return (
    <div className="empty-state">
      <svg
        className="empty-state__graphic"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle className="empty-state__ring empty-state__ring--1" cx={24} cy={24} r={8} />
        <circle className="empty-state__ring empty-state__ring--2" cx={24} cy={24} r={14} />
        <circle className="empty-state__ring empty-state__ring--3" cx={24} cy={24} r={20} />
        <circle className="empty-state__dot" cx={24} cy={24} r={2} />
      </svg>
      <p className="empty-state__title">{title}</p>
      <p className="empty-state__sub">{subtitle}</p>
    </div>
  );
}
